// extracted by mini-css-extract-plugin
export default {"userStack":"pCIgGX5FclK_6r1MM9zJ","avatarContainer":"RDwu8PvTNRyEXuEr4MOb","otherUsers":"lxWTuV1obj0wDEEcizDf"};